export default __webpack_public_path__ + "static/media/carousel-1.625c8732.png";